import {React, useEffect} from 'react';
//import { redirect } from 'react-router-dom';
import DiagonalCircleMenu from '../components/diagonal-circle-menu';
import CollabLogo from '../components/collab-logo'
import SideMenu from '../components/side-menu';

const Home = () => {
    const SIDE_WIDTH = 600;
    const TRANSITION_SPEED = '1s'
    
    const descriptionWrapper = {
        position: 'relative',
        overflow: 'auto',
        maxWidth: SIDE_WIDTH,
        width: SIDE_WIDTH,
        height: '550px',
        marginTop: '48px',
    }

    const fadeOut = {
        visibility: 'hidden',
        opacity: 0,
        transition: `visibility 0s ${TRANSITION_SPEED}, opacity ${TRANSITION_SPEED} linear` 
    }

    const blackScreen = {
        backgroundColor:'black', 
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
    }

    // Fade-in effects
    useEffect(() => {
        const black1 = document.getElementById('black-1');
        const black2 = document.getElementById('black-2');

        // Only fade in if the URL hash isn't 'skip'
        if (window.location.hash === '#skip' || window.innerWidth <= 768) {
            black1.style.visibility = 'hidden';
            black2.style.visibility = 'hidden';
        } else {
            black1.style.transition = fadeOut.transition;
            black1.style.opacity = fadeOut.opacity;
            black1.style.visibility = fadeOut.visibility;
        
            setTimeout(() => {
                black2.style.transition = fadeOut.transition;
                black2.style.opacity = fadeOut.opacity;
                black2.style.visibility = fadeOut.visibility;
            }, 1500);   
        }
    });

    return (
        <>

            <SideMenu mobileOnly='true' active=''/>

            <div id='black-1' style={{...blackScreen, zIndex: 5}}></div>
            <div id='black-2' style={{...blackScreen, zIndex: 3}}></div>
            <div className='project-intro'>
                <div className='menu-buffer'></div>
                <div className='project-description'>
                    <div className='main-logo' style={{height: 'auto', width: '250px'}}>
                        <CollabLogo />
                    </div>
                    <h1 style={{marginTop:'5px'}}>The&nbsp;History&nbsp;of&nbsp;the&nbsp;Pussy&nbsp;Palace</h1>
                    <h2 style={{letterSpacing: '5px'}}>A DIGITAL EXHIBIT</h2>
                    <div id='description-wrapper' style={descriptionWrapper}>
                        
                        <img className='hp-mob-img' alt='' src='/assets/images/home/Explore_Thumbnail.jpg'/>
                        <p id='p1' style={{position:'relative', zIndex:4}}>
                            Ever wondered what it’s like to visit a queer bathhouse?
                        </p>
                        
                        <p id='p2'>
                        The Pussy Palace was a series of sex-positive bathhouse events for queer women and trans people, organized by the Toronto Women’s Bathhouse Committee (1998–mid-2010s). On September 14, 2000, police raided the Palace, disrupting over 350 patrons in what became the last major queer bathhouse raid in Canadian history. 
                        </p>
                        <p id='p3'>
                        Spanning from the 1970s to the present, this interactive digital exhibit draws on 36 oral histories with organizers, patrons, and allies to trace the evolution of the Palace, the raid, and the radical sexual cultures that shaped this moment in Toronto’s LGBTQ+ history.
                        </p>
                        <p id='p4'>
                        Use the timeline to explore key chapters in the Palace’s story — or step into Explore the Palace to move through nine digitally reimagined rooms and experience what a typical night might have felt like.                        </p>
                    </div>
                </div>
                <div className='menu-buffer' style={{maxWidth:'50px'}}></div>
                <div style={{display:'flex', alignItems:'center'}}>
                    <DiagonalCircleMenu />
                </div>
                <div className='menu-buffer'></div>
            </div>
        </>
    )
}

export default Home;